<template>
  <div>
    <div class="search">
      <el-form :model="query">
        <div class="form-box">
          <el-form-item label="应用模块">
            <el-select
              v-model="query.applicationCode"
              @change="changeApplication"
              placeholder="请选择"
            >
              <el-option
                v-for="item in applicationCodeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单据名称">
            <el-select v-model="query.entityCode" placeholder="请选择" :disabled="entityDisabled">
              <el-option
                v-for="item in searchBillOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="启用" class="check-box">
            <el-select v-model="query.enableFlag" placeholder="请选择">
              <el-option
                v-for="item in enableOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div>
        <a href="javascript:;" class="btn btn-search" @click="loadList()">
          <img src="../../../../assets/tableImg/search.svg" alt="" />{{ $t('search.search') }}</a
        >
        <a href="javascript:;" class="btn btn-reset" @click="reset()">
          <img src="../../../../assets/tableImg/reset.svg" alt="" />{{ $t('search.reset') }}</a
        >
      </div>
    </div>
    <div class="content-box">
      <div>
        <buttonItem :buttonList="menuButtonList" @chooseClick="clickEvent"></buttonItem>
      </div>
      <div class="public-table">
        <vxe-table
          ref="xTable"
          border="outer"
          :data="tableData"
          :loading="load"
          height="410"
          show-overflow
          size="mini"
          column-min-width="120"
          stripe
          row-id="id"
          :checkbox-config="{ reserve: true }"
          @checkbox-all="selectChangeEvent"
          @checkbox-change="selectChangeEvent"
          @cell-dblclick="dblclick"
        >
          <vxe-table-column type="checkbox" width="60"></vxe-table-column>
          <vxe-table-column type="index" width="60" title="序号"></vxe-table-column>
          <vxe-table-column title="模块名字">
            <template #default="{ row }">
              <div>{{ formatText(row.applicationCode, applicationCodeOptions) }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column title="单据名称">
            <template #default="{ row }">
              <div>{{ formatCode(row.entityCode, entityList) }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column title="单据事件名称">
            <template #default="{ row }">
              <div>{{ formatCode(row.eventCode, eventList) }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="templateCode" title="单据模板编码"></vxe-table-column>
          <vxe-table-column field="templateName" title="凭证模板名称"></vxe-table-column>
          <vxe-table-column field="templateDesc" title="凭证模板描述"></vxe-table-column>
          <vxe-table-column field="enableFlag" title="启用"></vxe-table-column>
          <vxe-table-column field="ledgerCode" title="账套编码"></vxe-table-column>
          <vxe-table-column field="voucherCompanyCode" title="交易方代码"></vxe-table-column>
          <vxe-table-column field="voucherCompanyName" title="交易方名称"></vxe-table-column>
          <vxe-table-column field="voucherType" title="凭证类型"></vxe-table-column>
          <vxe-table-column field="referenceNo" title="参考编号"></vxe-table-column>
          <vxe-table-column field="companyCurrencyCode" title="本位币种"></vxe-table-column>
          <vxe-table-column field="exchangeType" title="汇率类型"></vxe-table-column>
          <vxe-table-column field="exchangeRate" title="汇率值"></vxe-table-column>
          <vxe-table-column field="exchangeDate" title="汇率日期"></vxe-table-column>
          <vxe-table-column field="entityDataId" title="业务单据ID"></vxe-table-column>
          <vxe-table-column field="entityDataNo" title="业务单据编号"></vxe-table-column>
          <vxe-table-column field="currencyCode" title="业务币种"></vxe-table-column>
          <vxe-table-column field="voucherDate" title="凭证日期"></vxe-table-column>
          <vxe-table-column field="postDate" title="过账日期"></vxe-table-column>
          <vxe-table-column field="accountCondition" title="会计条件"></vxe-table-column>
          <vxe-table-column field="entityUrl" title="摘要"></vxe-table-column>
          <vxe-table-column field="summary" title="业务单据链接"></vxe-table-column>
        </vxe-table>
      </div>
      <div class="pagination-block" v-if="page.total > 0">
        <div class="left"
          >选中{{ multipleSelection.length }}条,显示第
          {{ (page.pageNum - 1) * page.pageSize + 1 }} 条到
          {{
            (page.pageNum - 1) * page.pageSize + page.pageSize > page.total
              ? page.total
              : (page.pageNum - 1) * page.pageSize + page.pageSize
          }}
          条记录，共 {{ page.total }} 条记录</div
        >
        <el-pagination
          v-if="page.total > 0"
          class="right"
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handlePagination"
          :page-count="page.pages"
          :current-page="page.pageNum || 1"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="page.total"
          layout="sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import buttonItem from '../../../../components/ButtonItem';
  export default {
    name: 'voucherMod',
    components: {
      buttonItem,
    },
    data() {
      return {
        tableData: [],
        load: false,
        page: {
          pages: 1, //总共多少页
          pageNum: 1, //第几页
          pageSize: 10, //一页多少条数据
          total: 0, //总共多少条
        },
        multipleSelection: [],
        menuButtonList: [],
        applicationCodeOptions: [],
        billOptions: [],
        searchBillOptions: [], //搜索单据名称
        entityDisabled: true,
        query: {
          applicationCode: '',
          enableFlag: '',
          entityCode: '',
        },
        enableOptions: [
          { label: '是', value: 'Y' },
          { label: '否', value: 'N' },
        ],
        entityList: {},
        eventList: {},
      };
    },
    mounted() {
      this.loadList();
      this.getButtonList();
      this.loadOptions();
    },
    methods: {
      dblclick({ row }) {
        this.$router.push({
          path: '/accountingEngine/voucherDetail',
          query: { id: row.id, type: 'edit' },
        });
      },
      loadList() {
        this.load = true;
        let params = {
          ...this.query,
          ...this.page,
        };
        this.$axios.post('/financial/tAeVoucherHeaderTemplate/queryPage', params).then((res) => {
          this.tableData = res.data.data.records;
          this.page.total = res.data.data.total;
          this.load = false;
        });
      },
      changeApplication(val) {
        this.loadBill(val, 'search');
        this.entityDisabled = false;
        this.query.entityCode = '';
      },
      async loadOptions() {
        let list = await this.$baseRequest.functionalModList();
        let newArr = [];
        list.forEach((item) => {
          if (newArr.indexOf(item.applicationCode) === -1) {
            newArr.push(item.applicationCode);
            this.applicationCodeOptions.push({
              label: item.applicationName,
              value: item.applicationCode,
              enableFlag: item.enableFlag,
            });
          }
        });
        this.$axios.post('/maindata/dictData/queryKeyMapAppEntityEvent').then((res) => {
          let data = res.data.data;
          this.entityList = data.entity;
          this.eventList = data.event;
        });
      },
      async loadBill(val, type) {
        let options = [];
        this.searchBillOptions = [];
        this.billOptions = [];
        await this.$axios
          .post('/maindata/dictData/listDataDictByDataType', { dictType: val })
          .then((res) => {
            options = res.data.data;
            options.forEach((item) => {
              if (type === 'search') {
                this.searchBillOptions.push({
                  label: item.label,
                  value: item.value,
                  accountStatusCallback: item.remark,
                });
              } else {
                this.billOptions.push({
                  label: item.label,
                  value: item.value,
                  accountStatusCallback: item.remark,
                });
              }
            });
            this.billDisabled = false;
          });
      },
      handleSizeChange(val) {
        //每次重新选择每页条数，都需要从第一页开始查询
        this.page.pageNum = 1;
        this.page.pageSize = val;
        this.loadList();
      },
      handlePagination(val) {
        this.page.pageNum = val;
        this.loadList();
      },
      selectChangeEvent(val) {
        // 当允许翻页时，勾选checkbox需要将历史记录合并
        let allChecked = this.$refs.xTable.getCheckboxReserveRecords()[0]
          ? this.$refs.xTable.getCheckboxReserveRecords().concat(val.selection)
          : val.selection;
        this.multipleSelection = allChecked;
      },
      clickEvent(item) {
        switch (item) {
          case 'add':
            this.$router.push({
              path: '/accountingEngine/voucherDetail',
              query: { type: 'add' },
            });
            break;
          case 'delete':
            this.delete();
            break;
        }
      },
      delete() {
        let ids = [];
        const selectedList = this.$refs['xTable'].getSelectRecords();
        selectedList.forEach((item) => {
          ids.push(item.id);
        });
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs['xTable'].removeSelecteds();
            this.$axios.post('/financial/tAeVoucherHeaderTemplate/delVoucherHeaderTemplate', {
              idList: ids,
            });
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('cooperation.message.deleteSuccess'),
            });
            this.page.pageNum = 1;
            this.loadList();
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('cooperation.message.cancelled'),
            });
          });
      },
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      reset() {
        for (let key in this.query) {
          this.query[key] = '';
        }
        this.loadList();
      },
      formatText(val, option) {
        let text = '';
        option.forEach((item) => {
          if (item.value === val) {
            text = item.label;
          }
        });
        return text;
      },
      formatCode(val, option) {
        let text = '';
        Object.keys(option).forEach((item) => {
          if (item === val) {
            text = option[item];
          }
        });
        return text;
      },
    },
  };
</script>

<style scoped lang="scss">
  .search {
    margin-bottom: 10px;
    padding: 0 30px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .form-box {
      display: flex;
      .el-form-item {
        width: 320px;
        margin-left: 20px;
        margin-top: 18px;
        ::v-deep .el-form-item__label {
          width: 80px;
        }
        ::v-deep .el-form-item__content {
          margin-left: 80px;
        }
        ::v-deep .el-select {
          width: 100%;
        }
      }
      .item {
        display: flex;
        flex-wrap: wrap;
      }
    }

    .btn {
      width: 90px;
      height: 30px;
      display: inline-block;
      line-height: 30px;
      text-align: center;
      border-radius: 3px;
      img {
        vertical-align: middle;
        padding-right: 10px;
      }
    }

    .btn-search {
      background-color: #409eff;
      color: #ffffff;
    }
    .btn-reset {
      background-color: #ffffff;
      color: #409eff;
      border: 1px solid #e4e6eb;
    }
  }

  .content-box {
    padding: 20px 30px;
    background-color: #ffffff;
  }
</style>
